import React from "react";
import { urls } from "@ff-os/shared-utils/urls";
import styles from "./MagicLabelIcon.module.scss";

interface MagicLabelIconProps {
    className?: string;
}

export const MagicLabelIcon = ({ className = '' }: MagicLabelIconProps) => {
    return (
        <img
            src={urls.publicAssetUrl("003697e3-a85c-4b15-b2f6-74a5fa4c7773")}
            className={ `${styles.magicLabel} ${className}`}
            draggable="false"
        />
    );
};